// extracted by mini-css-extract-plugin
module.exports = {"bg":"S6FDj","scotch":"_3sxV8"};